import { InvalidUrlError } from '../../../common/errors/errors';
import { InventoryMapper } from '../../../common/inventory/mappers/InventoryMapper';
import { InventoryRecap } from '../../../common/inventory/models/InventoryRecap';
import { INVENTORY_QUERY_FRAGMENT } from '../../../common/inventory/services/InventoryService';
import { JavaProviderMapper } from '../../../common/reports/mappers/JavaProviderMapper';
import { ObjectStatsMapper } from '../../../common/reports/mappers/ObjectStatsMapper';
import { JavaProvider } from '../../../common/reports/models/JavaProvider';
import { ObjectStat } from '../../../common/reports/models/ObjectStat';
import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { ModelType } from '../../../common/utils/GQLIdEncoder';

export const GET_REPORT_SUMMARY_QUERY = `
query($reportId: ID!) {
  node(id: $reportId) {
    ... on ReportDone {
      inventory {
        ${INVENTORY_QUERY_FRAGMENT}
      }
      javaProviders {
        name
        version
        vulnerabilities {
          name
          url
        }
      }
      objectStats {
        type
        value
        count
      }
    }
  }
}`;

export type ReportSummary = { inventory: InventoryRecap | null; javaProviders: JavaProvider[]; objectStats: ObjectStat[] };

export class ReportSummaryRepository extends BaseGQLService {
  private readonly inventoryMapper = new InventoryMapper();
  private readonly javaProvidersMapper = new JavaProviderMapper();
  private readonly objectStatsMapper = new ObjectStatsMapper();

  async getSummary(reportId: number): Promise<ReportSummary> {
    return this.query(
      GET_REPORT_SUMMARY_QUERY,
      {
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
      },
      (data) => {
        if (!data.node) {
          throw new InvalidUrlError(`Invalid request: could not find Report ${reportId}`);
        }
        return {
          inventory: this.inventoryMapper.mapGQLModel(data.node.inventory),
          javaProviders: this.javaProvidersMapper.mapGQLModel(data.node.javaProviders),
          objectStats: this.objectStatsMapper.mapGQLModel(data.node.objectStats),
        };
      }
    );
  }
}
